import React from "react";
import ReactDOM from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import "./App.css";
import App from "./App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Initialize PostHog Analytics
if (process.env.REACT_APP_POSTHOG_KEY && process.env.REACT_APP_POSTHOG_KEY !== "phc_YOUR_POSTHOG_API_KEY_HERE") {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
    autocapture: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PostHogProvider client={posthog}>
    <App />
  </PostHogProvider>
);

if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}


